import { EPublishOfferErrorCode } from './publishOffer';

export interface IPublishInfo {
  /** Тип поведения */
  type: EPublishInfoType | null;
  /** Модель для отрисовки уведомления */
  message: IPublishInfoMessage | null;
  /** Услуги, которые пользователь потеряет */
  servicesToDeactivate: Array<IPublishInfoServicesToDeactivate> | null;
  /** Произошла внутренняя ошибка во время работы */
  checkFailed: boolean;
}
export interface IPublishInfoMessage {
  header: string;
  body: string;
  styleType: 'Warning' | 'Alert';
}

export interface IPublishInfoServicesToDeactivate {
  /** Тип услуги */
  serviceTypes: Array<string>;
  /** Название услуги */
  serviceName: string;
  /** Дата окончания услуг */
  paidTill: string;
}

export interface IPublishInfoError {
  errorCode: EPublishOfferErrorCode | null;
  errorMessage: string | null;
  errors: Array<TStringObject> | null;
}

export enum EPublishInfoType {
  Skip = 'Skip',
  Warning = 'Warning',
  Blocked = 'Blocked',
}
